import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_EVENT_COMMUNITY_LIST,
    CLEAR_EVENT_COMMUNITY_LIST_ERROR,
    LOAD_EVENT_COMMUNITY_LIST_REQUEST,
    LOAD_EVENT_COMMUNITY_LIST_SUCCESS,
    LOAD_EVENT_COMMUNITY_LIST_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_EVENT_COMMUNITY_LIST,
    CLEAR_ERROR: CLEAR_EVENT_COMMUNITY_LIST_ERROR,
    LOAD_REQUEST: LOAD_EVENT_COMMUNITY_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_EVENT_COMMUNITY_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_EVENT_COMMUNITY_LIST_FAILURE
}